var map = {
	"./slide_small0.png": "Nody",
	"./slide_small1.png": "p2lZ",
	"./slide_small2.png": "ojg0",
	"./slide_small3.png": "82mf",
	"./slide_small4.png": "411x"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1tSg";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/slide_small.*\.png$
// module id = 1tSg
// module chunks = 4